export const GAME_SERVICE = 'https://poker-api.testsdlc.in';